import { render, staticRenderFns } from "./MemoCard.vue?vue&type=template&id=cbde4e64&scoped=true&"
import script from "./MemoCard.vue?vue&type=script&lang=js&"
export * from "./MemoCard.vue?vue&type=script&lang=js&"
import style0 from "./MemoCard.vue?vue&type=style&index=0&id=cbde4e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbde4e64",
  null
  
)

export default component.exports